// test2064
(2064 && 0);
